<template>
    <div class="right_box">
      <div class="tips">
        彭祖世家网
      </div>
      <div style="height: 50px;line-height: 50px;color:#666666;font-size: 14px">
        共 <span>{{ table.count }}</span> 条数据
      </div>
      <div v-show="currentSet==1" class="topBox">
        <!--<el-select v-model="value1" placeholder="请选择" class="selects" @change="hanerTemolate">-->
        <!--<el-option-->
        <!--v-for="item in selectData"-->
        <!--:key="item.value"-->
        <!--:label="item.label"-->
        <!--:value="item.value"-->
        <!--/>-->
        <!--</el-select>-->
        <span v-for="(item,index) in selectData" :key="index" :class="currentTypeIndex==index?'btnType1':'btnType1_no'" @click="hanerTemolate(item,index)">{{ item.label }}</span>
        <div />
        <!--<div class="searchBox">-->
        <!--<el-input-->
        <!--v-model="value2"-->
        <!--class="searchs"-->
        <!--placeholder="请输入关键字"-->
        <!--/>-->
        <!--<i class="el-icon-search collect_search" @click="handleSearch" />-->
        <!--</div>-->
      </div>
      <div v-show="currentSet==2" class="topBox">
        <!--<el-select v-model="value1" placeholder="请选择" class="selects" @change="hanerTemolate">-->
        <!--<el-option-->
        <!--v-for="item in selectData"-->
        <!--:key="item.value"-->
        <!--:label="item.label"-->
        <!--:value="item.value"-->
        <!--/>-->
        <!--</el-select>-->
        <span v-for="(item,index) in selectData2" :key="index" :class="currentTypeIndex==index?'btnType1':'btnType1_no'" @click="hanerTemolate(item,index)">{{ item.label }}</span>
        <div />
        <!--<div class="searchBox">-->
        <!--<el-input-->
        <!--v-model="value2"-->
        <!--class="searchs"-->
        <!--placeholder="请输入关键字"-->
        <!--/>-->
        <!--<i class="el-icon-search collect_search" @click="handleSearch" />-->
        <!--</div>-->
      </div>
      <div class="PcshowBox">
        <!--<div class="cancelCollectBtn">-->
        <!--<el-button :disabled="ISShow" type="success" size="medium" class="quxiao" @click="cancelRemove('all')">-->
        <!--取消收藏-->
        <!--</el-button>-->
        <!--</div>-->
        <el-table
          :data="table.data"
          class="tableBox"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          style="width:100%"
          stripe
          @sort-change="sortTypeData"
          @selection-change="handleSelectionChange"
        >
          <!--<el-table-column-->
          <!--type="selection"-->
          <!--min-width="10%"-->
          <!--/>-->
          <el-table-column
            min-width="40%"
            label="标题"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.TEMPLATE_NAME=='资讯'" class="templateName" style="background-color: #84CCC9;">{{ scope.row.TEMPLATE_NAME }}</span>
                <span v-if="scope.row.TEMPLATE_NAME=='视频'" class="templateName" style="background-color: #7ECEF4;">{{ scope.row.TEMPLATE_NAME }}</span>
                <span v-if="scope.row.TEMPLATE_NAME=='图集'" class="templateName" style="background-color: #FACD89;">{{ scope.row.TEMPLATE_NAME }}</span>
                <span v-if="scope.row.TEMPLATE_NAME=='文库'" class="templateName" style="background-color: #F29C9F;">{{ scope.row.TEMPLATE_NAME }}</span>
                <span v-if="scope.row.TEMPLATE_NAME=='谱书'" class="templateName" style="background-color: #66f788;">{{ scope.row.TEMPLATE_NAME }}</span>
                <span v-if="scope.row.TEMPLATE_NAME=='谱文'" class="templateName" style="background-color: #317ee7;">{{ scope.row.TEMPLATE_NAME }}</span>
                <span v-if="scope.row.TEMPLATE_NAME=='谱系'" class="templateName" style="background-color: #e869f3;">{{ scope.row.TEMPLATE_NAME }}</span>
                <span class="content_name">{{ scope.row.CONTENT_TITLE }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="25%"
            prop="CREATE_DATE"
            label="收藏时间"
            sortable
          />
          <el-table-column
            min-width="15%"
            label="操作"
          >
            <template slot-scope="scope">
              <span class="Btn" @click="goDetail(scope.row)">
                阅读
              </span>
              <span class="cancelBtn" @click="cancelRemove(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <pagination
          :total="table.count"
          :pager="table.param.index"
          :pagesize="table.param.size"
          style="text-align:center;margin:40px 0 60px;"
          layout="sizes, pager, next, jumper"
          @pagersizechange="pagerSizeChange"
          @pagerchange="pagerChange"
        />
      </div>
    </div>
</template>

<script>
import pagination from '@/components/userCenter/pagination.vue'
import { findCmsUserUCMapPage, deleteCmsUCMap } from '@/api/api.js'
export default {
  name: 'Index',
  components: {
    pagination
  },
  inject: ['reload'],
  data() {
    return {
      zgw1: require('@/static/zgw1.png'),
      zgw2: require('@/static/zgw2.png'),
      py1: require('@/static/py1.png'),
      py2: require('@/static/py2.png'),
      currentSet: 1,
      value1: '全部分类', // ////选择的分类
      value2: '', // ///搜索值
      ISShow: true,
      currentTypeIndex: 0,
      selectData: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '谱书',
          value: '1'
        },
        {
          label: '谱文',
          value: '2'
        },
        {
          label: '谱系',
          value: '3'
        },
        {
          label: '人物',
          value: '4'
        },
        {
          label: '资讯',
          value: '9'
        }, {
          label: '视频',
          value: '8'

        }, {
          label: '图集',
          value: '7'
        }, {
          label: '文库',
          value: '10'
        }
      ],
      selectData2: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '谱书',
          value: '1'
        }, {
          label: '谱文',
          value: '2'

        }, {
          label: '谱系',
          value: '3'
        }
      ],
      table: {
        data: [],
        param: {
          userId: '',
          templateId: '',
          sortFieldName: '',
          sortType: '',
          index: 1,
          size: 10
        },
        count: 0,
        selectArry: ''
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      if (!this.table.param.templateId) {
        delete this.table.param.templateId
      }
      // console.log(this.table.param)
      this.table.param.userId = this.getLoca('userid')
      findCmsUserUCMapPage(this.table.param).then(response => {
        this.table.data = response.data.listMapData
        this.table.count = response.data.count
        // console.log(this.table.data)
      })
    },
    handleSearch() {
      if (this.value2) {
        this.table.param.search = this.value2
      }
      this.fetchData()
    },
    // 日期排序
    sortTypeData(param) {
      var orderObj = {
        'descending': 'DESC',
        'ascending': 'ASC'
      }
      this.table.param.sortFieldName = param.prop
      this.table.param.sortType = orderObj[param.order]
      this.fetchData()
    },
    pagerSizeChange: function(size) {
      this.table.param.size = size
      this.table.param.index = 1
      this.fetchData()
    },
    pagerChange: function(pager) {
      this.table.param.index = pager
      this.fetchData()
    },
    // 选中状态
    handleSelectionChange: function(res) {
      this.table.selectArry = res
      if (res.length >= 1) {
        this.ISShow = false
      } else {
        this.ISShow = true
      }
    },
    // //取消收藏单个和批量删除
    cancelRemove(thisOne) {
      var newMerry = []
      if (thisOne !== 'all') {
        newMerry.push(thisOne.CONTENT_ID)
        // userId.push(thisOne.USER_ID)
      } else {
        this.table.selectArry.forEach(a => {
          newMerry.push(a.CONTENT_ID)
        })
      }
      // console.log(this.table.selectArry[0].USER_ID)
      this.$confirm('确定要取消收藏吗?', '取消提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log(newMerry)
        deleteCmsUCMap({
          userId: this.getLoca('userid'),
          contentIds: newMerry.toString()
        }).then(response => {
          if (response.data) {
            this.$message({
              message: '恭喜你，取消收藏成功！',
              type: 'success'
            })
            this.reload()
          } else {
            this.$message.error(response.message)
          }
        })
      })
    },
    // 切换模板
    hanerTemolate(item, index) {
      this.currentTypeIndex = index
      this.table.param.templateId = item.value
      this.fetchData()
    },
    goDetail: function(item) {
      var href = ''
      if (item.COLLECTION_TYPE == 2) {
        if (item.TEMPLATE_NAME == '谱书') {
          href = 'sourceView?sourceId=' + item.CONTENT_ID + '&type=1'
        }
        if (item.TEMPLATE_NAME == '谱文') {
          href = 'sourceView?sourceId=' + item.CONTENT_ID + '&type=2'
        }
        if (item.TEMPLATE_NAME == '谱系') {
          href = 'sourceView?sourceId=' + item.CONTENT_ID + '&type=3'
        }
      } else {
        href = '/Detail?contentId=' + item.CONTENT_ID
      }
      window.open(href, '_blank')
    },
    changeSet(index) {
      this.currentSet = index
      this.table.param = {
        userId: '',
        templateId: '',
        sortFieldName: '',
        sortType: '',
        index: 1,
        size: 10
      }
      this.currentTypeIndex = 0
      this.fetchData()
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .cellSty{
        .cell{
            padding-left: 20px!important;
        }
    }
    .phoneBox{
        display: none;
    }
    .right_box{
            width: 840px;
            display: inline-block;
            vertical-align: top;
            background-color: #fff;
            padding: 0 30px;
            overflow: hidden;
            .tips{
                display: inline-block;
                padding-left: 7px;
                border-left: 3px solid #E0466E;
                height: 17px;
                line-height: 17px;
                margin-top: 30px;
                font-size: 18px;
            }
        }

    .toptitle {
        line-height: 40px;
        height: 40px;
        border-bottom: 1px solid #e5e5e5;
        span {
            display: inline-block;
            height: 39px;
            font-size: 14px;
            color: #4e4e4e;
            width: 72px;
            border-bottom: 2px solid #ed4040;
        }
    }
    .searchs{
        width: 217px;
        display: inline-block;
        margin-left: 12px;
        vertical-align: middle;
    }
    .collect_search{
        display: inline-block;
        position: absolute;
        width: 30px;
        height: 40px;
        font-size: 18px;
        line-height: 40px;
        color: #b3b3b3;
        right: 0;
        cursor: pointer;
    }
    .searchBox{
        position: relative;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
    }
    .topBox{
        padding: 18px 30px;
        padding-left: 10px;
        background-color: #F1F7FF;
        margin-bottom: 15px;
        .btnType1{
            padding: 5px 20px;
            border: 1px solid #E0466E;
            border-radius: 3px;
            color: #ffffff;
            font-size: 14px;
            background-color: #E0466E;
            margin-left: 15px;
            cursor: pointer;
        }
        .btnType1_no{
            padding: 5px 20px;
            border: 1px solid #E5E5E5;
            border-radius: 3px;
            color: #333333;
            font-size: 14px;
            background-color: #fff;
            margin-left: 15px;
            cursor: pointer;
        }
    }
    .selects{
        position:relative;
    }
    .quxiao{
        background-color: #ed4040!important;
        border: none!important;
    }
    .Btn{
        color: #5aa0fd;
        font-size: 14px;
        cursor: pointer;
    }
    ///收藏的单个删除功能添加
    .cancelBtn{
        color: #e0466e;
        font-size: 14px;
        margin-left: 10px;
        cursor: pointer;
    }
    .templateName{
        width: 38px;
        height: 22px;
        display: inline-block;
        color: #ffffff;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        border-radius: 3px;
        margin-right: 10px;
    }
    .content_name{
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        color: #333333;
        max-width: 330px;
        overflow: hidden;
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .myCollContent{
            padding: 0 10px;
        }
        .selects{
            width: 30vw;
        }
        .searchBox{
            width: 50vw;
        }
        .searchs{
            width: 45vw;
        }
        .PcshowBox{
            display: none;
        }
        .phoneBox{
            display: block;
            padding-top: 20px;
            .phoneList{
                position: relative;
                margin: 20px 0;
                .phoneNames{
                    width: calc( 100vw -  100px);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow:ellipsis
                }
                .cancelBtn{
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }

        }

    }
</style>
<style rel="stylesheet/scss" lang="scss">
    .myCollContent{
        .el-table .cell{
            padding-left: 30px!important;
        }
    }
</style>
